export default __webpack_public_path__ + "static/media/ChangeView.64416919.svg";